export default "__VITE_ASSET__CaQtAwz2__"